import { DashboardLayout } from '@/components/layout/DashboardLayout'
import { Building2, Filter, Users } from 'lucide-react'
import { EmpresaDetailModal } from '@/components/Empresas/Modals/EmpresaDetailModal'
import {
  PageToolbar,
  SegmentTabs,
  FilterBar,
  FilterSearch,
  FilterSelect,
  filterButtonClass,
} from '@/components/ui/page-toolbar'
import { ContatosTable } from '@/components/Empresas/ContatosTable'
import { EmpresaCreateModal } from '@/components/Empresas/Modals/EmpresaCreateModal'
import { EmpresasListTable } from '@/components/Empresas/EmpresasListTable'
import { EmpresasPagination } from '@/components/Empresas/EmpresasPagination'
import { useEmpresasPage } from '@/hooks/useEmpresasPage'
import { EMPRESA_STATUS_LABELS } from '@/pages/empresasPageConstants'

export default function Empresas() {
  const {
    searchEmpresa,
    setSearchEmpresa,
    searchContato,
    setSearchContato,
    page,
    setPage,
    selectedEmpresa,
    setSelectedEmpresa,
    filterNoContact,
    setFilterNoContact,
    filterSegmento,
    setFilterSegmento,
    filterStatus,
    setFilterStatus,
    parceiros,
    loading,
    showCreateModal,
    setShowCreateModal,
    viewType,
    setViewType,
    segmentos,
    totalCount,
    totalPages,
    paginatedEmpresas,
    paginatedContatos,
    handleSaved,
    handleSelectContato,
    pageSize,
  } = useEmpresasPage()

  return (
    <DashboardLayout
      title='Empresas'
    >
      <PageToolbar
        navigation={
          <SegmentTabs
            tabs={[
              { id: 'empresas', label: 'Empresas', icon: Building2 },
              { id: 'contatos', label: 'Contatos', icon: Users },
            ]}
            value={viewType}
            onChange={(v) => setViewType(v as 'empresas' | 'contatos')}
            ariaLabel='Visão de empresas'
          />
        }
        filters={
          <FilterBar>
            <FilterSearch
              value={viewType === 'empresas' ? searchEmpresa : searchContato}
              onChange={(v) => {
                if (viewType === 'empresas') setSearchEmpresa(v)
                else setSearchContato(v)
                setPage(1)
              }}
              placeholder={viewType === 'empresas' ? 'Buscar empresas...' : 'Buscar contatos...'}
            />
            <button
              type='button'
              onClick={() => {
                setFilterNoContact(!filterNoContact)
                setPage(1)
              }}
              className={filterButtonClass(filterNoContact)}
              aria-pressed={filterNoContact}
            >
              <Filter size={14} aria-hidden />
              Sem Contato
            </button>
            <FilterSelect
              value={filterSegmento}
              onChange={(v) => { setFilterSegmento(v); setPage(1) }}
              title='Segmento'
            >
              <option value=''>Todos segmentos</option>
              {segmentos.map((seg) => (
                <option key={seg} value={seg}>{seg}</option>
              ))}
            </FilterSelect>
            <FilterSelect
              value={filterStatus}
              onChange={(v) => { setFilterStatus(v); setPage(1) }}
              title='Status'
            >
              <option value=''>Todos status</option>
              {Object.entries(EMPRESA_STATUS_LABELS).map(([value, label]) => (
                <option key={value} value={value}>{label}</option>
              ))}
            </FilterSelect>
          </FilterBar>
        }
      />

      {viewType === 'empresas' ? (
        <EmpresasListTable
          empresas={paginatedEmpresas}
          loading={loading}
          onSelect={setSelectedEmpresa}
        />
      ) : (
        <ContatosTable contatos={paginatedContatos} loading={loading} onSelectContato={handleSelectContato} />
      )}

      <EmpresasPagination
        totalCount={totalCount}
        page={page}
        totalPages={totalPages}
        pageSize={pageSize}
        onPageChange={setPage}
      />

      <EmpresaDetailModal
        empresa={selectedEmpresa}
        onClose={() => setSelectedEmpresa(null)}
        onSaved={handleSaved}
        partners={parceiros}
      />

      <EmpresaCreateModal
        open={showCreateModal}
        onClose={() => setShowCreateModal(false)}
        onCreated={handleSaved}
      />
    </DashboardLayout>
  )
}
